<template>
  <div class="float-left">
    <v-card width="284" outlined class="mt-3 pt-0 d-flex mr-3">
      <v-card-text class="pa-0">
        <div class="float-left">
          <p style="font-size: 1rem;" class="mb-3 mt-3 ml-5 pt-1 black--text">
            {{ title }}
          </p>
          <p
            class="headline font-weight-light font-weight-bold mb-3 mt-3 ml-5 pt-1 black--text"
          >
            {{ comma_view(display_data) }}
          </p>
        </div>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      required: true,
    },
    display_data: {
      type: Number,
      required: true,
      default: 0,
    },
  },
  methods: {
    comma_view: function(value) {
      return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
  },
};
</script>
